import {
  ORG_CONSTANT_ALL,
  ORG_CONSTANT_GET,
  ORG_CONSTANT_DELETE,
  ORG_CONSTANT_PUT,
  ORG_CONSTANT_POST,
  ORG_CONSTANT_LOADING,
  ORG_CONSTANT_ERROR,
} from '../types';

import api from '../../../configs/api';
import graphqlClient from '../../../configs/graphqlClient';

export const organizationConstantCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: ORG_CONSTANT_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/organization-constant`,
      {
        ...payload,
      },
    );
    dispatch({ type: ORG_CONSTANT_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: ORG_CONSTANT_ERROR });
    throw new Error(error);
  }
};

export const organizationConstantAll = ({
  name = '',
  size = 10,
  page = 1,
}) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/organization-constant?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: ORG_CONSTANT_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: ORG_CONSTANT_ERROR });
    throw new Error(error);
  }
};

export const organizationConstantAllQuery = ({ query }) => async (dispatch) => {
  try {
    const queryResult = await graphqlClient.request(query);
    const data = queryResult?.findOrganizationConstants;
    //  console.log('Query Data', queryResult);
    if (!data) {
      dispatch({ type: ORG_CONSTANT_ERROR });
    }

    dispatch({ type: ORG_CONSTANT_ALL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: ORG_CONSTANT_ERROR });
    throw new Error(error);
  }
};

export const organizationConstantGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/organization-constant/${id}`,
    );
    if (status === 200) {
      dispatch({ type: ORG_CONSTANT_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: ORG_CONSTANT_ERROR });
    throw new Error(error);
  }
};

export const organizationConstantStateSet = (data) => async (dispatch) => {
  dispatch({ type: ORG_CONSTANT_ALL, payload: data });
};

export const organizationConstantPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: ORG_CONSTANT_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/organization-constant/${id}`,
      payload,
    );
    dispatch({ type: ORG_CONSTANT_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: ORG_CONSTANT_ERROR });
    throw new Error(error);
  }
};
export const organizationConstantDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: ORG_CONSTANT_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/organization-constant/${id}`,
    );
    dispatch({ type: ORG_CONSTANT_DELETE, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: ORG_CONSTANT_ERROR });
    throw new Error(error);
  }
};
